import { createSelector } from "@reduxjs/toolkit";

export const selectDefaultReducer = (state) => state.default;

export const selectTranslations = (state) => state.default.translations;

export const selectBasket = (state) => state.default.basket;

export const selectProducts = (state) => state.default.products;

export const selectProductIds = createSelector(
    [selectBasket],
    (basket) => basket.products.map((p) => p.id)
);

export const selectProductsCount = (state) => state.default.products.length;